import { CalendlyExpert } from '../../../../../features/experts/types/CalendlyExpert';
import { ExpertRole } from '../../../../../features/experts/types/ExpertRole';
import { useExpertsStore } from '../../../../../utils/stores/useExpertsStore';

interface UseVenereExpertsReturn {
  nutritionist: CalendlyExpert | null;
  physician: CalendlyExpert | null;
  admin: CalendlyExpert | null;
  getExpertByRole: (role: ExpertRole) => CalendlyExpert | null;
  hasExpert: (role: ExpertRole) => boolean;
}

export const useVenereExperts = (): UseVenereExpertsReturn => {
  const { experts } = useExpertsStore();

  const getExpertByRole = (role: ExpertRole): CalendlyExpert | null => {
    switch (role) {
      case ExpertRole.Nutritionist:
        return experts.nutritionist;
      case ExpertRole.Physician:
        return experts.physician;
      case ExpertRole.Admin:
        return experts.admin;
      default:
        return null;
    }
  };

  const hasExpert = (role: ExpertRole): boolean => {
    return getExpertByRole(role) !== null;
  };

  return {
    nutritionist: experts.nutritionist,
    physician: experts.physician,
    admin: experts.admin,
    getExpertByRole,
    hasExpert,
  };
}; 